import { Environment as GuestAccountEnv } from '@rcg/favorites';
import { Brand, BrandCode } from './Brand';

export interface SharedCommonConfig {
	imageBaseUrl: string;
}

export enum EnvironmentColor {
	Blue = 'blue',
	Green = 'green',
}

export interface CommonBrandConfig {
	imageBaseUrl: SharedCommonConfig['imageBaseUrl'];
	endpoints: CommonBrandConfigEndpoints;
}

export interface CommonBrandConfigEndpoints {
	bookingApi: string;
	universalNavigationApi: string;
}

export interface CommonConfig {
	endpoints: CommonConfigEndpoints;
	externalUrls: CommonExternalUrls;
	dictionaries: CommonConfigDictionaries;
	publicKeys: CommonConfigPublicKeys;
	brands: Record<BrandCode, CommonBrandConfig>;
}

export interface CommonConfigDictionaries {
	cruiseSearchClient: string;
	booking: string;
	bookingErrors: string;
}

export interface CommonConfigEndpoints {
	cruiseSearchApi: string;
	cruiseStandaloneSearchApi: string;
	globalizationApi: string;
	campaignsApi: string;
	cruiseSearchTimeout: number;
	eventsApi: string;
	gdpApi: string;
	nlsApi: string;
	userEmailOnlyLoginApi: string;
	userEmailOnlyValidateApi: string;
	userFavoritesApi: string;
	userMergeApi: string;
	userWatchlistApi: string;
	quickBookApi: string;
}

export interface CommonExternalUrls {
	shipReviews: string;
}

export interface CommonConfigPublicKeys {
	cookieRwdAudienceToken: string;
	cookieTdAudienceToken: string;
}

export interface EnvBrandConfig {
	baseUrl: string;
	mapsBaseUrl?: string;
	publicKeys: EnvBrandConfigPublicKeys;
	scripts: EnvBrandConfigScripts;
	resources: EnvBrandConfigResources;
}

export interface EnvBrandConfigPublicKeys {
	affirmApiKey: string;
	appDynamicsAppKey: string;
}

export interface EnvBrandConfigScripts {
	appDynamics: string;
}

export interface EnvBrandConfigResources {
	favicon: string;
}

export interface EnvConfig {
	env: string;
	endpoints: EnvConfigEndpoints & Partial<CommonConfigEndpoints>;
	publicKeys: EnvConfigPublicKeys & Partial<CommonConfigPublicKeys>;
	brands: Record<BrandCode, EnvBrandConfig>;
}

export interface EnvConfigEndpoints {
	affirmApi: string;
	dictionaryApi: string;
	utilsApi: string;
}

export interface EnvConfigPublicKeys {
	guestAccountClientId: string;
	launchDarklyClientSideId: string;
	utilsApiKey: string;
}

export interface ClientSideConfig {
	env: string;
	envColor: EnvironmentColor;
	guestAccountEnv: GuestAccountEnv;
	brand: Brand;
	baseUrl: string;
	mapsBaseUrl?: string;
	imageBaseUrl: string;
	endpoints: CommonConfigEndpoints & EnvConfigEndpoints;
	externalUrls: CommonExternalUrls;
	publicKeys: CommonConfigPublicKeys & EnvConfigPublicKeys & EnvBrandConfigPublicKeys;
	scripts: EnvBrandConfigScripts;
	resources: EnvBrandConfigResources;
	appVersion: string;
}

export interface ServerSideConfig {
	env: string;
	envColor: string;
	appVersion: string;
	brand: Brand;
	baseUrl: string;
	endpoints: ServerSideConfigEndpoints;
	dictionaries: CommonConfigDictionaries;
	secrets: ServerSideConfigSecrets;
}

export interface ServerSideConfigEndpoints extends Pick<CommonBrandConfigEndpoints, 'universalNavigationApi'> {
	cruiseSearchApi: string;
	cruiseStandaloneSearchApi: string;
	globalizationApi: string;
	campaignsApi: string;
	cruiseSearchTimeout: number;
	dictionaryApi: string;
}

export interface ServerSideConfigSecrets {
	launchDarklySdkKey: string;
	launchDarklyCommonSdkKey: string;
}
